import StationChecklistActionTypes from './station-checklist.types';

export const fetchStationChecklistStart = () => ({
  type: StationChecklistActionTypes.FETCH_STATION_CHECKLIST_START,
});

export const fetchStationChecklistSuccess = (checklist) => ({
  type: StationChecklistActionTypes.FETCH_STATION_CHECKLIST_SUCCESS,
  payload: checklist,
});

export const fetchStationChecklistFailure = (error) => ({
  type: StationChecklistActionTypes.FETCH_STATION_CHECKLIST_FAILURE,
  payload: error,
});

export const setSelectedStationChecklist = (station) => ({
  type: StationChecklistActionTypes.SET_SELECTED_STATION_CHECKLIST,
  payload: station,
});

export const setStationChecklistLoading = (loading) => ({
  type: StationChecklistActionTypes.SET_STATION_CHECKLIST_LOADING,
  payload: loading,
});

// Path: client/src/redux/stationChecklist/station-checklist.sagas.js
